





























import { Component, Vue, Inject } from "vue-property-decorator";
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";

@Component
export default class ChangeTicketSubjectModal extends Vue {
  // Injected
  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;
  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;
  // Refs
  public $refs!: {
    changeSubjectInput: HTMLFormElement;
  };
  // Data
  public subject = "";
  public isProcessing = false;
  // Getters
  public get ticket() {
    return this.$ticketData().ticket;
  }
  public get formIsValid() {
    return !this.$_.isEqual(this.subject, this.ticket.subject);
  }
  // Lifecycle Methods
  public created() {
    this.subject = this.ticket.subject;
    this.$nextTick(() => {
      this.$refs.changeSubjectInput.focus();
    });
  }
  // Methods
  public changeSubject() {
    if (this.isProcessing) return;
    if (!this.formIsValid) return;
    this.isProcessing = true;
    this.$ticketMethods
      .changeSubject(this.subject)
      .then(() => this.$emit("close"))
      .finally(() => {
        this.isProcessing = false;
      });
  }
}
